{
  "version": "1.0",
  "baseUrlPlaceholder": "{{baseUrl}}",
  "frontendBaseUrlPlaceholder": "{{frontendBaseUrl}}",
  "sections": [
    {
      "id": "digital-cards",
      "labelKey": "restApi.sectionDigitalCards",
      "endpoints": [
        {
          "id": "digital-cards-list",
          "method": "GET",
          "path": "/digital-cards",
          "labelKey": "restApi.listDigitalCardsLabel",
          "titleKey": "restApi.listDigitalCards",
          "descriptionKey": "restApi.listDigitalCardsDescription",
          "queryParams": [
            {
              "name": "templatesOnly",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.templatesOnlyDescription"
            },
            {
              "name": "email",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.emailFilterDescription"
            },
            {
              "name": "forTemplate",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.forTemplateDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards?templatesOnly=false', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"digitalCards\": [\n    {\n      \"profileId\": \"dc_a1B2c3D4e5F6\",\n      \"displayName\": \"John Doe\",\n      \"status\": \"active\",\n      \"isDefault\": false,\n      \"currentRenderId\": \"rnd_123\",\n      \"email\": \"john.doe@example.com\",\n      \"createdAt\": \"2025-02-07T12:00:00.000Z\",\n      \"publicUrl\": \"https://cards.example.com/dc_a1B2c3D4e5F6/rnd_123\"\n    }\n  ],\n  \"total\": 1\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "429": "{\n  \"error\": \"Too many requests\",\n  \"errorKey\": \"errors.too_many_requests\"\n}"
          }
        },
        {
          "id": "digital-cards-get",
          "method": "GET",
          "path": "/digital-cards/{profileId}",
          "labelKey": "restApi.getDigitalCardLabel",
          "titleKey": "restApi.getDigitalCard",
          "descriptionKey": "restApi.getDigitalCardDescription",
          "pathParams": [
            {
              "name": "profileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.profileIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/dc_a1B2c3D4e5F6', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"profileId\": \"dc_a1B2c3D4e5F6\",\n  \"displayName\": \"John Doe\",\n  \"status\": \"active\",\n  \"currentRenderId\": \"rnd_123\",\n  \"email\": \"john.doe@example.com\",\n  \"publicUrl\": \"https://cards.example.com/dc_a1B2c3D4e5F6/rnd_123\",\n  \"settings\": {\n    \"showQr\": true,\n    \"showAvatar\": true,\n    \"brandColorPrimary\": \"#0B5FFF\"\n  }\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "404": "{\n  \"error\": \"Digital card not found\",\n  \"errorKey\": \"errors.digital_card.not_found\"\n}"
          }
        },
        {
          "id": "digital-cards-employee",
          "method": "GET",
          "path": "/digital-cards/employees/{email}",
          "labelKey": "restApi.listEmployeeDigitalCardsLabel",
          "titleKey": "restApi.listEmployeeDigitalCards",
          "descriptionKey": "restApi.listEmployeeDigitalCardsDescription",
          "pathParams": [
            {
              "name": "email",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeEmailDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/employees/john.doe%40example.com', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"email\": \"john.doe@example.com\",\n  \"digitalCards\": [\n    {\n      \"profileId\": \"dc_a1B2c3D4e5F6\",\n      \"displayName\": \"John Doe\",\n      \"status\": \"active\",\n      \"email\": \"john.doe@example.com\",\n      \"publicUrl\": \"https://cards.example.com/dc_a1B2c3D4e5F6/rnd_123\"\n    }\n  ],\n  \"total\": 1\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "digital-cards-statistics",
          "method": "GET",
          "path": "/digital-cards/statistics",
          "labelKey": "restApi.domainStatisticsLabel",
          "titleKey": "restApi.domainStatistics",
          "descriptionKey": "restApi.domainStatisticsDescription",
          "queryParams": [
            {
              "name": "from",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.fromDescription"
            },
            {
              "name": "to",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.toDescription"
            },
            {
              "name": "page",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.pageDescription"
            },
            {
              "name": "limit",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.limitDescription"
            },
            {
              "name": "search",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.statisticsSearchDescription"
            },
            {
              "name": "sortBy",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.statisticsSortByDescription"
            },
            {
              "name": "order",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.statisticsOrderDescription"
            },
            {
              "name": "format",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.statisticsFormatDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/statistics?from=2025-01-01&to=2025-01-31&page=1&limit=50&sortBy=visits&order=DESC', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"summary\": {\n    \"totalLandings\": 1200,\n    \"totalInteractions\": 340,\n    \"totalSourceHits\": 980,\n    \"totalPreviews\": 150\n  },\n  \"columns\": {\n    \"mediums\": [\"qr\", \"nfc\", \"email\"],\n    \"elements\": [\"phone\", \"email\", \"save_contact\"]\n  },\n  \"data\": [\n    {\n      \"employee\": \"john.doe@example.com\",\n      \"cardName\": \"John Doe\",\n      \"visits\": 42,\n      \"mediumCounts\": { \"qr\": 20, \"nfc\": 12, \"email\": 10 },\n      \"elementCounts\": { \"phone\": 8, \"email\": 5, \"save_contact\": 3 }\n    }\n  ],\n  \"total\": 1\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "digital-cards-employee-statistics",
          "method": "GET",
          "path": "/digital-cards/statistics/employees/{email}",
          "labelKey": "restApi.employeeStatisticsLabel",
          "titleKey": "restApi.employeeStatistics",
          "descriptionKey": "restApi.employeeStatisticsDescription",
          "pathParams": [
            {
              "name": "email",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeEmailDescription",
              "required": true
            }
          ],
          "queryParams": [
            {
              "name": "from",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.fromDescription"
            },
            {
              "name": "to",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.toDescription"
            },
            {
              "name": "page",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.pageDescription"
            },
            {
              "name": "limit",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.limitDescription"
            },
            {
              "name": "sortBy",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.statisticsSortByDescription"
            },
            {
              "name": "order",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.statisticsOrderDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/statistics/employees/john.doe%40example.com?from=2025-01-01&to=2025-01-31&page=1&limit=50', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"email\": \"john.doe@example.com\",\n  \"summary\": {\n    \"totalLandings\": 42,\n    \"totalInteractions\": 13,\n    \"totalSourceHits\": 32,\n    \"totalPreviews\": 0\n  },\n  \"columns\": {\n    \"mediums\": [\"qr\", \"nfc\"],\n    \"elements\": [\"phone\", \"email\"]\n  },\n  \"data\": [\n    {\n      \"employee\": \"john.doe@example.com\",\n      \"cardName\": \"John Doe\",\n      \"visits\": 42,\n      \"mediumCounts\": { \"qr\": 20, \"nfc\": 12 },\n      \"elementCounts\": { \"phone\": 8, \"email\": 5 }\n    }\n  ],\n  \"total\": 1,\n  \"page\": 1,\n  \"limit\": 50\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "digital-cards-profile-statistics",
          "method": "GET",
          "path": "/digital-cards/{profileId}/statistics",
          "labelKey": "restApi.profileStatisticsLabel",
          "titleKey": "restApi.profileStatistics",
          "descriptionKey": "restApi.profileStatisticsDescription",
          "pathParams": [
            {
              "name": "profileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.profileIdDescription",
              "required": true
            }
          ],
          "queryParams": [
            {
              "name": "from",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.fromDescription"
            },
            {
              "name": "to",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.toDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/dc_a1B2c3D4e5F6/statistics?from=2025-01-01&to=2025-01-31', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"profileId\": \"dc_a1B2c3D4e5F6\",\n  \"displayName\": \"John Doe\",\n  \"byElement\": [{ \"element\": \"phone\", \"count\": 8 }],\n  \"byRender\": [{ \"renderId\": \"rnd_123\", \"count\": 40 }],\n  \"bySource\": [{ \"token\": \"src_qr\", \"medium\": \"qr\", \"count\": 20 }],\n  \"totalLandings\": 42,\n  \"totalInteractions\": 12,\n  \"totalSourceHits\": 35,\n  \"totalPreviews\": 5\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Employee digital card not found. Use profileId from GET /digital-cards?email=... or ?forTemplate=... (template IDs are not supported here).\",\n  \"errorKey\": \"errors.digital_card.employee_profile_required\"\n}"
          }
        },
        {
          "id": "digital-cards-custom-sources",
          "method": "GET",
          "path": "/digital-cards/custom-sources",
          "labelKey": "restApi.customSourcesLabel",
          "titleKey": "restApi.customSources",
          "descriptionKey": "restApi.customSourcesDescription",
          "queryParams": [
            {
              "name": "from",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.fromDescription"
            },
            {
              "name": "to",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.toDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/custom-sources?from=2025-01-01&to=2025-01-31', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"sources\": [\n    {\n      \"id\": \"cs_abc123\",\n      \"name\": \"Event booth\",\n      \"medium\": \"custom_event_booth\",\n      \"createdAt\": \"2025-01-10T09:00:00.000Z\",\n      \"totalHits\": 18\n    }\n  ]\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "digital-cards-source-tokens",
          "method": "POST",
          "path": "/digital-cards/{profileId}/source-tokens",
          "labelKey": "restApi.sourceTokensLabel",
          "titleKey": "restApi.sourceTokens",
          "descriptionKey": "restApi.sourceTokensDescription",
          "pathParams": [
            {
              "name": "profileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.profileIdDescription",
              "required": true
            }
          ],
          "bodyParams": [
            {
              "name": "mediums",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.mediumsDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/dc_a1B2c3D4e5F6/source-tokens', {\n  method: 'POST',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({ mediums: ['qr', 'nfc', 'email'] })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"qr\": { \"token\": \"tok_qr\", \"sourceUrl\": \"https://cards.example.com/s/tok_qr\" },\n  \"nfc\": { \"token\": \"tok_nfc\", \"sourceUrl\": \"https://cards.example.com/s/tok_nfc\" },\n  \"email\": { \"token\": \"tok_email\", \"sourceUrl\": \"https://cards.example.com/s/tok_email\" }\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\",\n  \"details\": { \"formErrors\": [], \"fieldErrors\": { \"mediums\": [\"Required\"] } }\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Employee digital card not found. Use profileId from GET /digital-cards?email=... or ?forTemplate=... (template IDs are not supported here).\",\n  \"errorKey\": \"errors.digital_card.employee_profile_required\"\n}"
          }
        },
        {
          "id": "digital-cards-entry",
          "method": "POST",
          "path": "/digital-cards/{profileId}/entry",
          "labelKey": "restApi.entryLinkLabel",
          "titleKey": "restApi.entryLink",
          "descriptionKey": "restApi.entryLinkDescription",
          "pathParams": [
            {
              "name": "profileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.profileIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/digital-cards/dc_a1B2c3D4e5F6/entry', {\n  method: 'POST',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"entryHash\": \"eh_abc123\",\n  \"entryUrl\": \"https://cards.example.com/e/eh_abc123\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Employee digital card not found. Use profileId from GET /digital-cards?email=... or ?forTemplate=... (template IDs are not supported here).\",\n  \"errorKey\": \"errors.digital_card.employee_profile_required\"\n}"
          }
        }
      ]
    },
    {
      "id": "footers",
      "labelKey": "restApi.sectionFooters",
      "endpoints": [
        {
          "id": "footers-list",
          "method": "GET",
          "path": "/footers",
          "labelKey": "restApi.listFootersLabel",
          "titleKey": "restApi.listFooters",
          "descriptionKey": "restApi.listFootersDescription",
          "queryParams": [
            {
              "name": "includeContent",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.includeContentDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/footers', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"footers\": [\n    {\n      \"id\": \"tmpl_123\",\n      \"name\": \"Default signature\",\n      \"order\": 0,\n      \"defaultForNewEmployee\": true,\n      \"numberOfInstallations\": 12,\n      \"numberOfAliases\": 2,\n      \"digitalCardProfileId\": null\n    }\n  ],\n  \"total\": 1\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "footers-get",
          "method": "GET",
          "path": "/footers/{id}",
          "labelKey": "restApi.getFooterLabel",
          "titleKey": "restApi.getFooter",
          "descriptionKey": "restApi.getFooterDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerIdDescription",
              "required": true
            }
          ],
          "queryParams": [
            {
              "name": "includeContent",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.includeContentDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/footers/tmpl_123?includeContent=true', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"tmpl_123\",\n  \"name\": \"Default signature\",\n  \"order\": 0,\n  \"content\": \"<table>...</table>\",\n  \"fullHtmlContent\": \"<!DOCTYPE html>...\",\n  \"numberOfInstallations\": 12\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Template with id tmpl_missing not found\",\n  \"errorKey\": \"errors.not_found\"\n}"
          }
        },
        {
          "id": "footers-install",
          "method": "POST",
          "path": "/footers/install",
          "labelKey": "restApi.installFooterLabel",
          "titleKey": "restApi.installFooter",
          "descriptionKey": "restApi.installFooterDescription",
          "bodyParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallIdDescription",
              "required": true
            },
            {
              "name": "email",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallEmailDescription"
            },
            {
              "name": "emails",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.footerInstallEmailsDescription"
            },
            {
              "name": "alias",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.footerInstallAliasDescription"
            },
            {
              "name": "all",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallAllDescription"
            },
            {
              "name": "group",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallGroupDescription"
            },
            {
              "name": "unit",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallUnitDescription"
            },
            {
              "name": "branch",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallBranchDescription"
            },
            {
              "name": "installMode",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.footerInstallModeDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/footers/install', {\n  method: 'POST',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({ id: 'tmpl_123', email: 'john.doe@example.com', installMode: 'ext' })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"updated\": 1,\n  \"isFirstInstallation\": false\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        }
      ]
    },
    {
      "id": "backgrounds",
      "labelKey": "restApi.sectionBackgrounds",
      "endpoints": [
        {
          "id": "backgrounds-list",
          "method": "GET",
          "path": "/backgrounds",
          "labelKey": "restApi.listBackgroundsLabel",
          "titleKey": "restApi.listBackgrounds",
          "descriptionKey": "restApi.listBackgroundsDescription",
          "requestExample": "fetch('{{baseUrl}}/backgrounds', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"backgrounds\": [{ \"id\": \"bg_123\", \"name\": \"Office wall\", \"settings\": { \"bannerType\": \"gradient\", \"showLogo\": true } }],\n  \"total\": 1\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "backgrounds-get",
          "method": "GET",
          "path": "/backgrounds/{id}",
          "labelKey": "restApi.getBackgroundLabel",
          "titleKey": "restApi.getBackground",
          "descriptionKey": "restApi.getBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/bg_123', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"bg_123\",\n  \"name\": \"Office wall\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Background not found\",\n  \"errorKey\": \"errors.not_found\"\n}"
          }
        },
        {
          "id": "backgrounds-create",
          "method": "POST",
          "path": "/backgrounds",
          "labelKey": "restApi.createBackgroundLabel",
          "titleKey": "restApi.createBackground",
          "descriptionKey": "restApi.createBackgroundDescription",
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundNameDescription",
              "required": true
            },
            {
              "name": "digitalCardProfileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundProfileIdDescription"
            },
            {
              "name": "settings",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.backgroundSettingsDescription",
              "required": true,
              "properties": [
                {
                  "name": "bannerType",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsBannerTypeDescription"
                },
                {
                  "name": "bannerGradientStart",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsGradientStartDescription"
                },
                {
                  "name": "bannerGradientEnd",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsGradientEndDescription"
                },
                {
                  "name": "bannerImageUrl",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsImageUrlDescription"
                },
                {
                  "name": "qrLabel",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsQrLabelDescription"
                },
                {
                  "name": "showLogo",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.bgSettingsShowLogoDescription"
                }
              ]
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds', {\n  method: 'POST',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Office wall',\n    digitalCardProfileId: 'dc_a1B2',\n    settings: {\n      bannerType: 'gradient',\n      bannerGradientStart: '#0B5FFF',\n      bannerGradientEnd: '#083B99',\n      showLogo: true,\n      qrLabel: 'Scan me'\n    }\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "201": "{\n  \"id\": \"bg_123\",\n  \"name\": \"Office wall\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "backgrounds-update",
          "method": "PUT",
          "path": "/backgrounds/{id}",
          "labelKey": "restApi.updateBackgroundLabel",
          "titleKey": "restApi.updateBackground",
          "descriptionKey": "restApi.updateBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/bg_123', {\n  method: 'PUT',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Office wall v2',\n    settings: { bannerType: 'image', bannerImageUrl: 'https://cdn.example.com/bg.png', showLogo: true }\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"bg_123\",\n  \"name\": \"Office wall v2\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          },
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundNameDescription"
            },
            {
              "name": "digitalCardProfileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundProfileIdDescription"
            },
            {
              "name": "settings",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.backgroundSettingsDescription",
              "properties": [
                {
                  "name": "bannerType",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsBannerTypeDescription"
                },
                {
                  "name": "bannerGradientStart",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsGradientStartDescription"
                },
                {
                  "name": "bannerGradientEnd",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsGradientEndDescription"
                },
                {
                  "name": "bannerImageUrl",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsImageUrlDescription"
                },
                {
                  "name": "qrLabel",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.bgSettingsQrLabelDescription"
                },
                {
                  "name": "showLogo",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.bgSettingsShowLogoDescription"
                }
              ]
            }
          ]
        },
        {
          "id": "backgrounds-delete",
          "method": "DELETE",
          "path": "/backgrounds/{id}",
          "labelKey": "restApi.deleteBackgroundLabel",
          "titleKey": "restApi.deleteBackground",
          "descriptionKey": "restApi.deleteBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/bg_123', {\n  method: 'DELETE',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => console.log(res.status)).catch(console.error);",
          "responseSamples": {
            "204": null,
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "meet-backgrounds-list",
          "method": "GET",
          "path": "/backgrounds/meets",
          "labelKey": "restApi.listMeetBackgroundsLabel",
          "titleKey": "restApi.listMeetBackgrounds",
          "descriptionKey": "restApi.listMeetBackgroundsDescription",
          "requestExample": "fetch('{{baseUrl}}/backgrounds/meets', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"meetBackgrounds\": [{ \"id\": \"mb_123\", \"name\": \"Meet default\", \"isDefault\": true }],\n  \"total\": 1\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "meet-backgrounds-get",
          "method": "GET",
          "path": "/backgrounds/meets/{id}",
          "labelKey": "restApi.getMeetBackgroundLabel",
          "titleKey": "restApi.getMeetBackground",
          "descriptionKey": "restApi.getMeetBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.meetBackgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/meets/mb_123', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"mb_123\",\n  \"name\": \"Meet default\",\n  \"isDefault\": true\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Meet background not found\",\n  \"errorKey\": \"errors.not_found\"\n}"
          }
        },
        {
          "id": "meet-backgrounds-create",
          "method": "POST",
          "path": "/backgrounds/meets",
          "labelKey": "restApi.createMeetBackgroundLabel",
          "titleKey": "restApi.createMeetBackground",
          "descriptionKey": "restApi.createMeetBackgroundDescription",
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundNameDescription",
              "required": true
            },
            {
              "name": "isDefault",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.meetBackgroundDefaultDescription"
            },
            {
              "name": "digitalCardProfileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundProfileIdDescription"
            },
            {
              "name": "settings",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.meetBackgroundSettingsDescription",
              "required": true,
              "properties": [
                {
                  "name": "layoutVariant",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLayoutVariantDescription"
                },
                {
                  "name": "barWidth",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsBarWidthDescription"
                },
                {
                  "name": "corner",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsCornerDescription"
                },
                {
                  "name": "logoCorner",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLogoCornerDescription"
                },
                {
                  "name": "showQrCaption",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowQrCaptionDescription"
                },
                {
                  "name": "qrCaption",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsQrCaptionDescription"
                },
                {
                  "name": "showEmployeeName",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowEmployeeNameDescription"
                },
                {
                  "name": "showJobTitle",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowJobTitleDescription"
                },
                {
                  "name": "showLogo",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowLogoDescription"
                },
                {
                  "name": "logoUrl",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLogoUrlDescription"
                },
                {
                  "name": "opacity",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsOpacityDescription"
                },
                {
                  "name": "qrBackgroundColor",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsQrBgColorDescription"
                },
                {
                  "name": "marginPx",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsMarginDescription"
                },
                {
                  "name": "sizeRatio",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsSizeRatioDescription"
                },
                {
                  "name": "logoOpacity",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsLogoOpacityDescription"
                },
                {
                  "name": "logoBackgroundColor",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLogoBgColorDescription"
                },
                {
                  "name": "logoMarginPx",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsLogoMarginDescription"
                },
                {
                  "name": "logoSizeRatio",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsLogoSizeRatioDescription"
                }
              ]
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/meets', {\n  method: 'POST',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Meet default',\n    isDefault: true,\n    digitalCardProfileId: 'dc_a1B2',\n    settings: {\n      layoutVariant: 'corner',\n      corner: 'bottom-right',\n      showQrCaption: true,\n      qrCaption: 'Scan to save my contact',\n      showEmployeeName: true,\n      showJobTitle: true,\n      showLogo: true,\n      sizeRatio: 0.7\n    }\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "201": "{\n  \"id\": \"mb_123\",\n  \"name\": \"Meet default\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "meet-backgrounds-update",
          "method": "PUT",
          "path": "/backgrounds/meets/{id}",
          "labelKey": "restApi.updateMeetBackgroundLabel",
          "titleKey": "restApi.updateMeetBackground",
          "descriptionKey": "restApi.updateMeetBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.meetBackgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/meets/mb_123', {\n  method: 'PUT',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Meet updated',\n    settings: { layoutVariant: 'bottom-bar', barWidth: 'full', showLogo: false }\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"mb_123\",\n  \"name\": \"Meet updated\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          },
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundNameDescription"
            },
            {
              "name": "isDefault",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.meetBackgroundDefaultDescription"
            },
            {
              "name": "digitalCardProfileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.backgroundProfileIdDescription"
            },
            {
              "name": "settings",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.meetBackgroundSettingsDescription",
              "properties": [
                {
                  "name": "layoutVariant",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLayoutVariantDescription"
                },
                {
                  "name": "barWidth",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsBarWidthDescription"
                },
                {
                  "name": "corner",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsCornerDescription"
                },
                {
                  "name": "logoCorner",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLogoCornerDescription"
                },
                {
                  "name": "showQrCaption",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowQrCaptionDescription"
                },
                {
                  "name": "qrCaption",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsQrCaptionDescription"
                },
                {
                  "name": "showEmployeeName",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowEmployeeNameDescription"
                },
                {
                  "name": "showJobTitle",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowJobTitleDescription"
                },
                {
                  "name": "showLogo",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.meetSettingsShowLogoDescription"
                },
                {
                  "name": "logoUrl",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLogoUrlDescription"
                },
                {
                  "name": "opacity",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsOpacityDescription"
                },
                {
                  "name": "qrBackgroundColor",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsQrBgColorDescription"
                },
                {
                  "name": "marginPx",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsMarginDescription"
                },
                {
                  "name": "sizeRatio",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsSizeRatioDescription"
                },
                {
                  "name": "logoOpacity",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsLogoOpacityDescription"
                },
                {
                  "name": "logoBackgroundColor",
                  "typeKey": "restApi.typeString",
                  "descriptionKey": "restApi.meetSettingsLogoBgColorDescription"
                },
                {
                  "name": "logoMarginPx",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsLogoMarginDescription"
                },
                {
                  "name": "logoSizeRatio",
                  "typeKey": "restApi.typeNumber",
                  "descriptionKey": "restApi.meetSettingsLogoSizeRatioDescription"
                }
              ]
            }
          ]
        },
        {
          "id": "meet-backgrounds-default",
          "method": "PUT",
          "path": "/backgrounds/meets/{id}/default",
          "labelKey": "restApi.setDefaultMeetBackgroundLabel",
          "titleKey": "restApi.setDefaultMeetBackground",
          "descriptionKey": "restApi.setDefaultMeetBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.meetBackgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/meets/mb_123/default', {\n  method: 'PUT',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"mb_123\",\n  \"isDefault\": true\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "meet-backgrounds-delete",
          "method": "DELETE",
          "path": "/backgrounds/meets/{id}",
          "labelKey": "restApi.deleteMeetBackgroundLabel",
          "titleKey": "restApi.deleteMeetBackground",
          "descriptionKey": "restApi.deleteMeetBackgroundDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.meetBackgroundIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/backgrounds/meets/mb_123', {\n  method: 'DELETE',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => console.log(res.status)).catch(console.error);",
          "responseSamples": {
            "204": null,
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        }
      ]
    },
    {
      "id": "settings",
      "labelKey": "restApi.sectionSettings",
      "endpoints": [
        {
          "id": "settings-get",
          "method": "GET",
          "path": "/settings",
          "labelKey": "restApi.getSettingsLabel",
          "titleKey": "restApi.getSettings",
          "descriptionKey": "restApi.getSettingsDescription",
          "requestExample": "fetch('{{baseUrl}}/settings', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"domain\": \"example.com\",\n  \"language\": \"en\",\n  \"avatarEnabled\": true,\n  \"linksEnabled\": true,\n  \"handwrittenEnabled\": true,\n  \"badgesEnabled\": true,\n  \"absenceEnabled\": false,\n  \"analyticLinksEnabled\": true,\n  \"lockSignatureEditing\": false,\n  \"digitalCardProfileId\": null\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "settings-put",
          "method": "PUT",
          "path": "/settings",
          "labelKey": "restApi.saveSettingsLabel",
          "titleKey": "restApi.saveSettings",
          "descriptionKey": "restApi.saveSettingsDescription",
          "bodyParams": [
            {
              "name": "language",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsLanguageDescription"
            },
            {
              "name": "overwritingDataBySync",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsOverwriteDataDescription"
            },
            {
              "name": "overwritingDataBySyncAndRemove",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsOverwriteDataRemoveDescription"
            },
            {
              "name": "overwritingPhotoBySync",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsOverwritePhotoDescription"
            },
            {
              "name": "updateSignatureWhenGoogleDataChange",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsUpdateOnGoogleChangeDescription"
            },
            {
              "name": "confirmationOfSignatureInstallationByUser",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsConfirmInstallDescription"
            },
            {
              "name": "bannerDisablingByUser",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsBannerDisableDescription"
            },
            {
              "name": "defaultCountryCallingCode",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.settingsCallingCodeDescription"
            },
            {
              "name": "analyticLinksEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsAnalyticLinksDescription"
            },
            {
              "name": "absenceEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsAbsenceEnabledDescription"
            },
            {
              "name": "absenceLabel",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsAbsenceLabelDescription"
            },
            {
              "name": "absenceDaysAhead",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.settingsAbsenceDaysDescription"
            },
            {
              "name": "dailySignatureReinstallEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsDailyReinstallDescription"
            },
            {
              "name": "signatureReinstallTime",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsReinstallTimeDescription"
            },
            {
              "name": "mobileLabel",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsMobileLabelDescription"
            },
            {
              "name": "phoneLabel",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsPhoneLabelDescription"
            },
            {
              "name": "emailLabel",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsEmailLabelDescription"
            },
            {
              "name": "customLabel",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsCustomLabelDescription"
            },
            {
              "name": "customLabelVariable",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsCustomLabelVarDescription"
            },
            {
              "name": "labelColor",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsLabelColorDescription"
            },
            {
              "name": "labelTextColor",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsLabelTextColorDescription"
            },
            {
              "name": "proxy",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.settingsProxyDescription",
              "properties": [
                {
                  "name": "active",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.settingsProxyActiveDescription",
                  "required": true
                },
                {
                  "name": "activeAll",
                  "typeKey": "restApi.typeBoolean",
                  "descriptionKey": "restApi.settingsProxyActiveAllDescription",
                  "required": true
                },
                {
                  "name": "emails",
                  "typeKey": "restApi.typeArray",
                  "descriptionKey": "restApi.settingsProxyEmailsDescription",
                  "required": true
                }
              ]
            },
            {
              "name": "internalSignature",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsInternalSignatureDescription"
            },
            {
              "name": "domainRulesEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsDomainRulesDescription"
            },
            {
              "name": "lockSignatureEditing",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsLockEditingDescription"
            },
            {
              "name": "avatarEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsAvatarEnabledDescription"
            },
            {
              "name": "linksEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsLinksEnabledDescription"
            },
            {
              "name": "handwrittenEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsHandwrittenEnabledDescription"
            },
            {
              "name": "badgesEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsBadgesEnabledDescription"
            },
            {
              "name": "firstInstallationEmailEnabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.settingsFirstInstallEmailDescription"
            },
            {
              "name": "digitalCardProfileId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.settingsDigitalCardProfileDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/settings', {\n  method: 'PUT',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    language: 'pl',\n    avatarEnabled: true,\n    linksEnabled: true,\n    absenceEnabled: false,\n    lockSignatureEditing: true\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"domain\": \"example.com\",\n  \"language\": \"pl\",\n  \"avatarEnabled\": true,\n  \"lockSignatureEditing\": true\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        }
      ]
    },
    {
      "id": "company",
      "labelKey": "restApi.sectionCompany",
      "endpoints": [
        {
          "id": "company-get",
          "method": "GET",
          "path": "/company",
          "labelKey": "restApi.getCompanyLabel",
          "titleKey": "restApi.getCompany",
          "descriptionKey": "restApi.getCompanyDescription",
          "requestExample": "fetch('{{baseUrl}}/company', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"domain\": \"example.com\",\n  \"name\": \"Example Inc\",\n  \"website\": \"https://example.com\",\n  \"address\": \"Main St 1\",\n  \"phone\": \"+48123456789\",\n  \"contactPersonEmail\": \"jane.doe@example.com\",\n  \"photoUrl\": \"https://cdn.example.com/logo.png\",\n  \"imageWidth\": 100,\n  \"imageHeight\": 100\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "company-put",
          "method": "PUT",
          "path": "/company",
          "labelKey": "restApi.saveCompanyLabel",
          "titleKey": "restApi.saveCompany",
          "descriptionKey": "restApi.saveCompanyDescription",
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.companyNameDescription"
            },
            {
              "name": "website",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.companyWebsiteDescription"
            },
            {
              "name": "address",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.companyAddressDescription"
            },
            {
              "name": "phone",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.companyPhoneDescription"
            },
            {
              "name": "contactPersonEmail",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.companyContactPersonEmailDescription"
            },
            {
              "name": "photoUrl",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.companyPhotoUrlDescription"
            },
            {
              "name": "originalImageWidth",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.companyOriginalImageWidthDescription"
            },
            {
              "name": "originalImageHeight",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.companyOriginalImageHeightDescription"
            },
            {
              "name": "imageWidth",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.companyImageWidthDescription"
            },
            {
              "name": "imageHeight",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.companyImageHeightDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/company', {\n  method: 'PUT',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Example Inc',\n    website: 'https://example.com',\n    address: 'Main St 1',\n    phone: '+48123456789',\n    contactPersonEmail: 'jane.doe@example.com'\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"domain\": \"example.com\",\n  \"name\": \"Example Inc\",\n  \"website\": \"https://example.com\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        }
      ]
    },
    {
      "id": "employees",
      "labelKey": "restApi.sectionEmployees",
      "endpoints": [
        {
          "id": "employees-list",
          "method": "GET",
          "path": "/employees",
          "labelKey": "restApi.listEmployeesLabel",
          "titleKey": "restApi.listEmployees",
          "descriptionKey": "restApi.listEmployeesDescription",
          "queryParams": [
            {
              "name": "page",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.pageDescription"
            },
            {
              "name": "limit",
              "typeKey": "restApi.typeNumber",
              "descriptionKey": "restApi.limitDescription"
            },
            {
              "name": "phrase",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesPhraseDescription"
            },
            {
              "name": "sortBy",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesSortByDescription"
            },
            {
              "name": "order",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesOrderDescription"
            },
            {
              "name": "signatureTemplateId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesSignatureTemplateIdDescription"
            },
            {
              "name": "signatureInternalTemplateId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesInternalTemplateIdDescription"
            },
            {
              "name": "signatureInstalled",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesSignatureInstalledDescription"
            },
            {
              "name": "excludedFromSignatures",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesExcludedDescription"
            },
            {
              "name": "branchId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeesBranchIdDescription"
            },
            {
              "name": "aliases",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.employeesAliasesDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/employees?page=1&limit=50&phrase=john&order=ASC', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"employees\": [{ \"id\": \"john.doe@example.com\", \"email\": \"john.doe@example.com\", \"fullName\": \"John Doe\", \"signatureTemplateId\": \"tmpl_123\" }],\n  \"total\": 1,\n  \"page\": 1,\n  \"limit\": 50\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "employees-get",
          "method": "GET",
          "path": "/employees/{email}",
          "labelKey": "restApi.getEmployeeLabel",
          "titleKey": "restApi.getEmployee",
          "descriptionKey": "restApi.getEmployeeDescription",
          "pathParams": [
            {
              "name": "email",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeEmailDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/employees/john.doe%40example.com', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"john.doe@example.com\",\n  \"email\": \"john.doe@example.com\",\n  \"fullName\": \"John Doe\",\n  \"givenName\": \"John\",\n  \"familyName\": \"Doe\",\n  \"dynamicVariables\": { \"title\": \"Engineer\" },\n  \"branchId\": \"br_123\",\n  \"aliases\": []\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Employee not found\",\n  \"errorKey\": \"errors.employee.not_found\"\n}"
          }
        },
        {
          "id": "employees-update",
          "method": "PUT",
          "path": "/employees/{email}",
          "labelKey": "restApi.updateEmployeeLabel",
          "titleKey": "restApi.updateEmployee",
          "descriptionKey": "restApi.updateEmployeeDescription",
          "pathParams": [
            {
              "name": "email",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeEmailDescription",
              "required": true
            }
          ],
          "bodyParams": [
            {
              "name": "givenName",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeGivenNameDescription"
            },
            {
              "name": "familyName",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeFamilyNameDescription"
            },
            {
              "name": "fullName",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeFullNameDescription"
            },
            {
              "name": "userAbout",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeUserAboutDescription"
            },
            {
              "name": "gender",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeGenderDescription"
            },
            {
              "name": "countryOfOrigin",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeCountryOfOriginDescription"
            },
            {
              "name": "excludedFromSignatures",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.employeeExcludedFromSignaturesDescription"
            },
            {
              "name": "bannerDisabled",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.employeeBannerDisabledDescription"
            },
            {
              "name": "thumbnailPhotoUrl",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeThumbnailPhotoUrlDescription"
            },
            {
              "name": "localAvatar",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.employeeLocalAvatarDescription"
            },
            {
              "name": "dynamicVariables",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.employeeDynamicVariablesDescription"
            },
            {
              "name": "customLinks",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.employeeCustomLinksDescription"
            },
            {
              "name": "vcard",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.employeeVcardDescription"
            },
            {
              "name": "handwrittenSignature",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.employeeHandwrittenDescription"
            },
            {
              "name": "badges",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.employeeBadgesDescription"
            },
            {
              "name": "branchId",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.employeeBranchIdDescription"
            },
            {
              "name": "branchVariables",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.employeeBranchVariablesDescription"
            },
            {
              "name": "installSignature",
              "typeKey": "restApi.typeBoolean",
              "descriptionKey": "restApi.employeeInstallSignatureDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/employees/john.doe%40example.com', {\n  method: 'PUT',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    givenName: 'John',\n    familyName: 'Doe',\n    dynamicVariables: { title: 'Engineer', phoneNumber: '+48123456789' },\n    customLinks: [{ text: 'LinkedIn', url: 'https://linkedin.com/in/johndoe' }],\n    branchId: 'br_123',\n    installSignature: true\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"john.doe@example.com\",\n  \"email\": \"john.doe@example.com\",\n  \"fullName\": \"John Doe\",\n  \"givenName\": \"John\",\n  \"familyName\": \"Doe\",\n  \"dynamicVariables\": { \"title\": \"Engineer\" },\n  \"branchId\": \"br_123\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Employee not found\",\n  \"errorKey\": \"errors.employee.not_found\"\n}"
          }
        }
      ]
    },
    {
      "id": "branches",
      "labelKey": "restApi.sectionBranches",
      "endpoints": [
        {
          "id": "branches-list",
          "method": "GET",
          "path": "/branches",
          "labelKey": "restApi.listBranchesLabel",
          "titleKey": "restApi.listBranches",
          "descriptionKey": "restApi.listBranchesDescription",
          "requestExample": "fetch('{{baseUrl}}/branches', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"branches\": [{ \"id\": \"br_123\", \"name\": \"Warsaw\", \"variables\": { \"branchCity\": { \"name\": \"branchCity\", \"defaultValue\": \"Warsaw\" } }, \"employeeIds\": [] }],\n  \"total\": 1\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "branches-get",
          "method": "GET",
          "path": "/branches/{id}",
          "labelKey": "restApi.getBranchLabel",
          "titleKey": "restApi.getBranch",
          "descriptionKey": "restApi.getBranchDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.branchIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/branches/br_123', {\n  method: 'GET',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"br_123\",\n  \"name\": \"Warsaw\",\n  \"variables\": {},\n  \"employeeIds\": []\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}",
            "404": "{\n  \"error\": \"Branch not found\",\n  \"errorKey\": \"errors.branch.not_found\"\n}"
          }
        },
        {
          "id": "branches-create",
          "method": "POST",
          "path": "/branches",
          "labelKey": "restApi.createBranchLabel",
          "titleKey": "restApi.createBranch",
          "descriptionKey": "restApi.createBranchDescription",
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.branchNameDescription",
              "required": true
            },
            {
              "name": "variables",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.branchVariablesDescription",
              "required": true,
              "properties": [
                {
                  "name": "branchName",
                  "typeKey": "restApi.typeObject",
                  "descriptionKey": "restApi.branchVariableExampleDescription",
                  "properties": [
                    {
                      "name": "name",
                      "typeKey": "restApi.typeString",
                      "descriptionKey": "restApi.branchVariableNameDescription",
                      "required": true
                    },
                    {
                      "name": "label",
                      "typeKey": "restApi.typeString",
                      "descriptionKey": "restApi.branchVariableLabelDescription"
                    },
                    {
                      "name": "defaultValue",
                      "typeKey": "restApi.typeString",
                      "descriptionKey": "restApi.branchVariableDefaultDescription"
                    },
                    {
                      "name": "iconUrl",
                      "typeKey": "restApi.typeString",
                      "descriptionKey": "restApi.branchVariableIconDescription"
                    },
                    {
                      "name": "overridable",
                      "typeKey": "restApi.typeBoolean",
                      "descriptionKey": "restApi.branchVariableOverridableDescription"
                    },
                    {
                      "name": "mandatory",
                      "typeKey": "restApi.typeBoolean",
                      "descriptionKey": "restApi.branchVariableMandatoryDescription"
                    }
                  ]
                }
              ]
            },
            {
              "name": "employeeIds",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.branchEmployeeIdsDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/branches', {\n  method: 'POST',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Warsaw',\n    variables: {\n      branchCity: { name: 'branchCity', label: 'City', defaultValue: 'Warsaw', overridable: true, mandatory: false }\n    },\n    employeeIds: ['john.doe@example.com']\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "201": "{\n  \"id\": \"br_123\",\n  \"name\": \"Warsaw\",\n  \"variables\": { \"branchCity\": { \"name\": \"branchCity\", \"defaultValue\": \"Warsaw\" } },\n  \"employeeIds\": [\"john.doe@example.com\"]\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "branches-update",
          "method": "PUT",
          "path": "/branches/{id}",
          "labelKey": "restApi.updateBranchLabel",
          "titleKey": "restApi.updateBranch",
          "descriptionKey": "restApi.updateBranchDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.branchIdDescription",
              "required": true
            }
          ],
          "bodyParams": [
            {
              "name": "name",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.branchNameDescription"
            },
            {
              "name": "variables",
              "typeKey": "restApi.typeObject",
              "descriptionKey": "restApi.branchVariablesDescription"
            },
            {
              "name": "employeeIds",
              "typeKey": "restApi.typeArray",
              "descriptionKey": "restApi.branchEmployeeIdsDescription"
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/branches/br_123', {\n  method: 'PUT',\n  headers: {\n    'Authorization': 'Bearer <token>',\n    'Content-Type': 'application/json'\n  },\n  body: JSON.stringify({\n    name: 'Krakow',\n    employeeIds: ['john.doe@example.com', 'jane.doe@example.com']\n  })\n}).then(res => res.json()).then(console.log).catch(console.error);",
          "responseSamples": {
            "200": "{\n  \"id\": \"br_123\",\n  \"name\": \"Krakow\"\n}",
            "400": "{\n  \"error\": \"Validation failed\",\n  \"errorKey\": \"errors.validation_failed\"\n}",
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        },
        {
          "id": "branches-delete",
          "method": "DELETE",
          "path": "/branches/{id}",
          "labelKey": "restApi.deleteBranchLabel",
          "titleKey": "restApi.deleteBranch",
          "descriptionKey": "restApi.deleteBranchDescription",
          "pathParams": [
            {
              "name": "id",
              "typeKey": "restApi.typeString",
              "descriptionKey": "restApi.branchIdDescription",
              "required": true
            }
          ],
          "requestExample": "fetch('{{baseUrl}}/branches/br_123', {\n  method: 'DELETE',\n  headers: { 'Authorization': 'Bearer <token>' }\n}).then(res => console.log(res.status)).catch(console.error);",
          "responseSamples": {
            "204": null,
            "401": "{\n  \"error\": \"Invalid API token\",\n  \"errorKey\": \"errors.api_token.invalid\"\n}",
            "403": "{\n  \"error\": \"REST API not available for this plan\",\n  \"errorKey\": \"errors.plan.feature_not_available\"\n}"
          }
        }
      ]
    }
  ]
}
